<template>
<div><h3>Building Reconaissance Form</h3>
<div class="wrapper">
<tabs nav-style="tabs" v-model="activeTabIndex">
    <tab header="Reconnaissance Form">
    <projectHeader :project="project" ref="projectHeader"/>
    <surveyHeader :survey="surveyDto" ref="surveyHeader"/>
    <div class="tab-content">
        <form class="form form-horizontal" v-on:submit.prevent data-vv-scope="reconForm">
            <h4>Identification</h4>
            <div  style="float: clear">
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('reconForm.temporaryFieldId') }">
                    <label class="col-md-2 control-label text-label">Temporary Field ID</label>
                    <div class="col-md-4">
                        <input type="text" name="temporaryFieldId" class="form-control" v-model="reconFormDto.fieldNumber" v-validate="'required'">
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('reconForm.historicName') }">
                    <label class="col-md-2 control-label text-label">Historic Name</label>
                    <div class="col-md-4">
                        <input type="text" name="historicName" class="form-control" v-model="reconFormDto.historicName" v-validate="'required'">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Other Common Name</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="reconFormDto.otherName">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Ownership Type</label>
                    <div class="col-md-2">                        
                        <select class="form-control" v-model='reconFormDto.landownerTypeId'>
                            <option disabled value=''>Select a value</option>
                            <option v-for="t in landownerTypeList" v-bind:value="t.id">
                                {{t.description}}
                            </option>                       
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Current Function Type</label>
                    <div v-for="t in functionList" class="col-md-1">
                        <div  class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedCurrentFunction" v-bind:id="'currentFunction' + t.description" v-bind:value="t.buildingFunctionId">
                                    <label v-bind:for="'currentFunction' + t.description">{{ t.description}}</label>
                            </input>
                        </div>
                    </div>
                </div>
            </div>
            <h4>Location</h4>
            <div style="float: clear">
                <div class="form-group" >
                    <label class="col-md-2 control-label text-label">Street Address</label>
                    <div class="col-md-4" v-bind:class="{ 'has-error': errors.has('reconForm.streetAddress') }">
                        <input type="text" name="streetAddress" class="form-control" v-model="reconFormDto.streetAddress" v-validate="'required'">
                    </div>
                    <label class="col-md-1 control-label text-label">Parcel ID</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="reconFormDto.parcelId">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">City/Town</label>
                    <div class="col-md-4" v-bind:class="{ 'has-error': errors.has('reconForm.streetAddress') }">
                        <input type="text" name="city" class="form-control" v-model="reconFormDto.city" v-validate="'required'">
                    </div>
                    <label class="col-md-1 control-label text-label">Vicinity</label>
                    <div class="col-md-1">
                        <div  class="checkbox checkbox-inline" style="margin-top:0px">
                            <input type="checkbox" v-model="reconFormDto.isVicinity" id="vicinityCB" >
                                <label for="vicinityCB">&nbsp;</label>
                            </input>
                        </div>
                    </div>
                    <label class="col-md-1 control-label text-label">County</label>
                    <div class="col-md-3" v-bind:class="{ 'has-error': errors.has('reconForm.county') }">
                        <select name="county" class="form-control" v-model="reconFormDto.countyId" v-validate="'required'">
                            <option disabled value="">Select a value</option>
                            <option v-for="county in countyList" v-bind:value="county.countyId">
                                {{county.description}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Subdivision/Plat</label>
                    <div class="col-md-3">
                        <input type="text" class="form-control" v-model="reconFormDto.subdivision">
                    </div>
                    <label class="col-md-1 control-label text-label">Block(s)</label>
                    <div class="col-md-2">
                        <input type="text" class="form-control" v-model="reconFormDto.block">
                    </div>
                    <label class="col-md-1 control-label text-label">Lot(s)</label>
                    <div class="col-md-3">
                        <input type="text" class="form-control" v-model="reconFormDto.lot">
                    </div>
                </div>
            </div>
            <h4>Construction and Alteration</h4>
            <div style="float: clear">
                <div class="form-group">
                    <div class="col-md-10 col-md-offset-2">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Date</th>
                                    <th>Estimated</th>
                                    <th>Comment</th>
                                    <th>Source</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="date in reconFormDto.constructionDateList">
                                    <td>{{date.constructionDateTypeDescription}}</td>
                                    <td>{{date.date}}</td>
                                    <td>{{date.isEstimate ? 'Yes' : 'No'}}</td>
                                    <td>{{date.comment}}</td>
                                    <td>{{date.source}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1 col-md-offset-10">
                        <button class="form-contol btn" v-on:click="$refs['constructionDateModal'].open()">Add Construction Dates</button>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Architect(s)/Builder(s)</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="reconFormDto.architect"></input>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Historic Function Type</label>
                    <div v-for="t in functionList" class="col-md-1">
                        <div  class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedHistoricFunction" v-bind:id="'historicFunction' + t.description" v-bind:value="t.buildingFunctionId">
                                    <label v-bind:for="'historicFunction' + t.description">{{ t.description}}</label>
                            </input>
                        </div>
                    </div>
                </div>
            </div>            
            <h4>Architectural Description</h4>
            <div style="float: clear">
                <div class="form-group">
                    <label class="col-md-2 control-label">Style</label>
                    <div class="col-md-2">
                        <select class="form-control" v-model="reconFormDto.buildingStyleId">
                            <option disabled value="">Select a value</option>
                            <option v-for="style in buildingStyleList" v-bind:value="style.buildingStyleId">
                                {{style.description}}
                            </option>
                        </select>
                    </div>
                    <label class="col-md-1 control-label">Type/Form</label>
                    <div class="col-md-2">
                        <select class="form-control" v-model="reconFormDto.buildingTypeId">
                            <option value=''> Select a value</option>
                            <option v-for="val in buildingTypeList" v-bind:value="val.buildingTypeId" :disabled="val.isHeader">
                                {{val.description}}
                            </option>
                        </select>
                    </div>
                    <label class="col-md-1 control-label">Stories</label>
                    <div  class="col-md-1">
                        <select class="form-control" v-model="reconFormDto.storyId">
                            <option disabled value="">Select</option>
                            <option v-for="story in storyList" v-bind:value="story.storyId">
                                {{story.description}}
                            </option>
                        </select>
                    </div>
                    <label class="col-md-1 control-label">Replaced</label>
                    <div  class="col-md-1">
                        <div  class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="reconFormDto.replacedDoors" id="replacedDoorsCB" >
                                <label for="replacedDoorsCB">Doors</label>
                            </input>
                        </div>
                    </div>
                    <div  class="col-md-1">
                        <div  class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="reconFormDto.replacedWindows" id="replacedWindowsCB" >
                                <label for="replacedWindowsCB">Windows</label>
                            </input>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-10 col-md-offset-2">
                    <table class="table">
                        <thead>
                            <tr>
                                <th style="width:20%">Element</th>
                                <th style="width:40%">Type</th>
                                <th style="width:40%">Material</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="element in reconFormDto.buildingElementList" :key="element.buildingElementId">
                                <td><strong>{{element.description}}</strong></td>
                                <td>
                                    <select class="form-control" v-model="element.buildingElementTypeId" v-validate="'required'">
                                        <option disabled value=''>Select a value</option>
                                        <option v-for="elementType in elementTypeList.filter(x => {return x.buildingElementId === element.buildingElementId})" v-bind:value="elementType.elementTypeId">
                                            {{elementType.description}}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <select class="form-control" v-model="element.buildingElementMaterialId" v-validate="'required'">
                                        <option disabled value=''>Select a value</option>
                                        <option v-for="elementType in elementMaterialList.filter(x => {return x.buildingElementId === element.buildingElementId})" v-bind:value="elementType.elementMaterialId">
                                            {{elementType.description}}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Notable Features</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="reconFormDto.notableFeatures"></input>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Outbuildings</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="reconFormDto.outbuildings"></input>
                    </div>
                </div>
            </div>
            <h4>Preservation and Planning</h4>
            <div style="float: clear">
                <div class="form-group">
                    <label class="col-md-2  control-label text-label">Integrity</label>
                    <div class="col-md-4" v-bind:class="{ 'has-error': errors.has('reconForm.integrity') }">
                        <select name="integrity" class="form-control" v-model="reconFormDto.buildingIntegrityId" v-validate="'required'">
                            <option disabled value="">Select a value</option>
                            <option v-for="integrity in buildingIntegrityList" v-bind:value="integrity.buildingIntegrityId">
                                {{integrity.description}}
                            </option>
                        </select>
                    </div>
                    <label class="col-md-2 control-label text-label">Condition</label>
                    <div class="col-md-4" v-bind:class="{ 'has-error': errors.has('reconForm.condition') }">
                        <select name="condition" class="form-control" v-model="reconFormDto.buildingConditionId" v-validate="'required'">
                            <option disabled value="">Select a value</option>
                            <option v-for="condition in buildingConditionList" v-bind:value="condition.buildingConditionId">
                                {{condition.description}}
                            </option>
                        </select>
                    </div>
                </div>                    
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('reconForm.conditionComments') }">
                    <label class="col-md-2 control-label text-label">Comments</label>
                    <div class="col-md-10">
                        <input name="conditionComments" type="text" class="form-control" v-model="reconFormDto.conditionComment" v-validate="'required'"></input>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Priority for Intensive Survey</label>
                    <div class="col-md-4" v-bind:class="{ 'has-error': errors.has('reconForm.priority') }">
                        <select name="priority" class="form-control" v-model="reconFormDto.surveyPriorityId" v-validate="'required'">
                            <option disabled value="">Select a value</option>
                            <option v-for="priority in priorityList" v-bind:value="priority.surveyPriorityId">
                                {{priority.description}}
                            </option>
                        </select>
                    </div>
                    <label class="col-md-2 control-label text-label">Potential Eligibility</label>
                    <div  class="col-md-1">
                        <div  class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="reconFormDto.isPotentialLocal" id="potentialLocalCB" >
                                <label for="potentialLocalCB">Local</label>
                            </input>
                        </div>
                    </div>
                    <div  class="col-md-2">
                        <div  class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="reconFormDto.isPotentialNRHP" id="potentialNRHPCB" >
                                <label for="potentialNRHPCB">National Register of Historic Places</label>
                            </input>
                        </div>
                    </div>
                    <div  class="col-md-1">
                        <div  class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="reconFormDto.isPotentialUnknown" id="potentialUnknownCB">
                                <label for="potentialUnknownCB">Unknown</label>
                            </input>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('reconForm.generalComments') }">
                    <label class="col-md-2 control-label text-label">Comments</label>
                    <div class="col-md-10">
                        <input name="generalComments" type="text" class="form-control" v-model="reconFormDto.preservationComment" v-validate="'required'"></input>
                    </div>
                </div>
            </div>
            <h4>Site History</h4>
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('reconForm.buildingHistory') }">
                <label class="col-md-2 control-label text-label">Describe</label>
                <div class="col-md-10">
                    <textarea name="buildingHistory" class="form-control" rows="6" v-model="reconFormDto.buildingHistory" v-validate="'required'"></textarea>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-6 col-md-offset-2">
                    <validationResultDisplay :validationResult="validationResult"></validationResultDisplay>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-1 col-md-offset-2">
                    <button class="btn btn-primary" v-on:click="saveForm">Save</button>
                </div>
            </div>
        </form>
        <modal ref="constructionDateModal">
            <div slot="header" class="row">
                <h3 class="pull-left">Construction Dates</h3>
                <button class="btn pull-right" v-on:click="$refs['constructionDateModal'].close()">X</button>
            </div>
            <div slot="body">
                <div class="form form-horizontal" data-vv-scope="constructionDates">
                    <div class="row">
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionDates.dateType') }">
                            <label class="col-md-4 control-label">Date type</label>
                            <div class="col-md-8">
                                <select name="dateType" class="form-control" v-model="constructionDateDto.constructionDateTypeId" v-validate="'required'" data-vv-scope="constructionDates">
                                    <option disabled value="">Select a value</option>
                                    <option  v-for="dateType in constructionDateTypes" v-bind:value="dateType.constructionDateTypeId">
                                        {{dateType.description}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionDates.date') }">
                            <label class="col-md-4 control-label">Date</label>
                            <div class="col-md-8">
                                <input name="date" type="text" class="form-control" v-model="constructionDateDto.date" v-validate="'required'" data-vv-scope="constructionDates">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group">
                            <label class="col-md-4 control-label">Estimated</label>
                            <div class=" col-md-2">
                                <div class="checkbox checkbox-inline" style="padding-top:0px">
                                    <input id='estimateCB' type="checkbox" v-model="constructionDateDto.isEstimate"  data-vv-scope="constructionDates">
                                        <label for='estimateCB'>&nbsp;</label>
                                    </input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionDates.comment') }">
                            <label class="col-md-4 control-label">Comment</label>
                            <div class="col-md-8">
                                <input type="text" name="comment" class="form-control" v-model="constructionDateDto.comment" v-validate="'required'" data-vv-scope="constructionDates">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionDates.source') }">
                            <label class="col-md-4 control-label">Source</label>
                            <div class="col-md-8">
                                <input type="text" name="source" class="form-control" v-model="constructionDateDto.source" v-validate="'required'" data-vv-scope="constructionDates">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <div class="row">
                    <button name="buttonDone" class="btn btn-primary col-md-3" v-on:click="constructionDatesDone()">Done</button>
                    <button name="buttonMore" class="btn btn-primary col-md-3 pull-right" v-on:click="constructionDatesMore()">More</button>
                </div>
            </div>
        </modal>
        <div v-show="isDebug">
            <h3>DEBUG</h3>
            <pre>
                {{reconFormDto}}
            </pre>
        </div>
    </div>        
    </tab>
    <tab header="Documents">
        <reconFormDocuments :reconForm="reconFormDto" />
    </tab>
    <tab header="Workflow">
        <projectHeader v-bind:project="project"></projectHeader>
        <div style="margin-top: 20px;"><workflow :workflowId="reconFormWorkflowId" :parentId="reconFormDto.buildingReconFormId" ref="workflow" v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess"></workflow></div>
    </tab>
</tabs>
</div>
</div>
</template>

<script>
import { tab, tabs } from 'vue-strap'
import modal from '@/components/Modal.vue'
import validationResultDisplay from '@/components/ValidationResultDisplay'
import surveyHeader from '@/components/SurveyHeader'
import projectHeader from '@/components/ProjectHeader'
import workflow from '@/components/Workflow'
import reconFormDocuments from '@/components/ReconFormDocuments'

import historicBuildingService from '@/services/siteForm/historicBuildingService'
import buildingReconFormService from '@/services/buildingReconFormService'
import loggingService from '@/services/util/loggingService'
import isolateService from '@/services/isolateService'
import countyService from '@/services/countyService'
import projectService from '@/services/projectService'
import workflowService from '@/services/workflowService'

import buildingSurveyService from '@/services/buildingSurveyService'

export default {
    components: {
        isLoading: false,
        tab,
        tabs,
        modal,
        validationResultDisplay,
        surveyHeader,
        projectHeader,
        reconFormDocuments,
        workflow
    },
    data: function () {
        return {
            //screen handling
            activeTabIndex: 0,
            isDebug: false,
            validationResult: {},
            //Dtos
            project: {},
            surveyDto: {},
            reconFormDto: {},
            constructionDates: [],
            constructionDateDto: {},
            selectedCurrentFunction: [],
            selectedHistoricFunction: [],
            //Lookups
            landownerTypeList: [],
            functionList: [],
            constructionDateTypes: [],
            buildingStyleList: [],
            buildingTypeList: [],
            storyList: [],
            buildingIntegrityList: [],
            buildingConditionList: [],
            priorityList: [],
            countyList: [],
            buildingType: '3',
            mediaList: []

        }
    },
    computed: {
        reconFormWorkflowId: function () {
            return workflowService.WorkflowEnum.BuildingReconForm
        }
    },
    mounted () {
        this.loadLookups().then(result => {
            this.loadData().then(result2 => {
            })
        })
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'BuildingReconForm', message)
        },
        loadLookups () {
            return countyService.listLookup(this.$http).then(response => {
                this.countyList = response.data
                this.landownerTypeList = isolateService.getLandownerList()
                this.functionList = historicBuildingService.getBuildingFunctionList()
                this.constructionDateTypes = historicBuildingService.getConstructionDateTypes()
                this.buildingStyleList = historicBuildingService.getBuildingStyleList()
                var rawTypeList = historicBuildingService.getBuildingTypeList()
                historicBuildingService.getBuildingTypeCategory().forEach(category => {
                    this.buildingTypeList.push({
                        buildingTypeId: 1000 + category.buildingCategoryId,
                        isHeader: 1,
                        description: category.description.toUpperCase()
                    })
                    var subset = rawTypeList.filter(t => { return t.buildingCategoryId === category.buildingCategoryId })
                    this.buildingTypeList = this.buildingTypeList.concat(subset)
                })
                this.storyList = historicBuildingService.getStoryList()
                this.elementList = historicBuildingService.getElementList()
                this.elementTypeList = historicBuildingService.getElementTypeList()
                this.elementMaterialList = historicBuildingService.getElementMaterialList()
                this.buildingIntegrityList = historicBuildingService.getBuildingIntegrityList()
                this.buildingConditionList = historicBuildingService.getBuildingConditionList()
                this.priorityList = historicBuildingService.getPriorityList()
                return response
            })
        },
        loadProject () {
            return projectService.get(this.$http, this.surveyDto.projectId).then(result => {
                this.project = result.data
                return result
            })
        },
        loadSurvey (buildingSurveyId) {
            this.log('Loading survey: ' + buildingSurveyId)
            return buildingSurveyService.get(this.$http, buildingSurveyId).then(result => {
                this.surveyDto = result.data
                this.log('Survey Found: ' + this.surveyDto.surveyName)

                this.reconFormDto.buildingElementList.forEach(x => {
                    x.description = this.elementList.find(y => { return x.buildingElementId === y.buildingElementId }).description
                })

                //add unsaved building elements
                this.elementList.forEach(ele => {
                    if (!this.reconFormDto.buildingElementList.some(x => x.buildingElementId === ele.buildingElementId)) {
                        this.reconFormDto.buildingElementList.push(
                            {
                                buildingElementId: ele.buildingElementId,
                                description: ele.description,
                                buildingElementTypeId: '',
                                buildingElementMaterialId: ''
                            })
                    }
                })

                this.reconFormDto.constructionDateList.forEach(x => {
                    this.log('Looking for id: ' + x.constructionDateTypeId)
                    x.constructionDateTypeDescription = this.constructionDateTypes.find(y => { return x.constructionDateTypeId === y.constructionDateTypeId }).description
                    this.log('Description: ' + x.constructionDateTypeDescription)
                })
                return this.loadProject()
            })
        },
        loadForm (formId) {
            if (!formId) return Promise.resolve(this.createReconForm())

            return buildingReconFormService.get(this.$http, formId).then(result => {
                this.log('loading form')
                this.reconFormDto = result.data

                var historicFunctions = this.reconFormDto.buildingFunctionList
                    .filter(x => { return x.isHistoric })
                    .map(y => { return y.buildingFunctionId })
                this.selectedHistoricFunction = historicFunctions

                var currentFunctions = this.reconFormDto.buildingFunctionList
                    .filter(x => { return x.isCurrent })
                    .map(y => { return y.buildingFunctionId })
                this.selectedCurrentFunction = currentFunctions

                if (!this.reconFormDto.buildingElementList || this.reconFormDto.buildingElementList.length === 0) {
                    this.reconFormDto.buildingElementList = this.elementList.map(element => {
                        return {
                            buildingElementId: element.buildingElementId,
                            description: element.description,
                            buildingElementTypeId: '',
                            buildingElementMaterialId: ''
                        }
                    })
                }
                return result
            })
        },
        loadData () {
            var formId = this.$route.params.buildingReconFormId
            this.log(`formId found: ${formId}`)
            return this.loadForm(formId).then(result => {
                this.log(`Loading Survey: ${formId}`)
                this.loadSurvey(this.reconFormDto.buildingSurveyId).then(result2 => {
                    this.log('Done!')
                    return result2
                })
            })
        },
        createReconForm () {
            this.log('Creating recon form')
            this.reconFormDto = {
                buildingSurveyId: this.$route.query.buildingSurveyId,
                recordingTypeId: 2, //FOR TESTING
                landownerTypeId: '',
                countyId: '',
                buildingStyleId: '',
                buildingTypeId: '',
                storyId: '',
                buildingIntegrityId: '',
                buildingConditionId: '',
                surveyPriorityId: '',
                constructionDateList: []
            }

            this.log('Creating element building list')

            this.reconFormDto.buildingElementList = this.elementList.map(element => {
                return {
                    buildingElementId: element.buildingElementId,
                    description: element.description,
                    buildingElementTypeId: '',
                    buildingElementMaterialId: ''
                }
            })
            this.log('element building list length: ' + this.reconFormDto.buildingElementList.length)

            return
        },
        constructionDatesDone () {
            this.$validator.validateAll('constructionDates').then((isValid) => {
                this.log('Construction date valid? ' + isValid)
                if (isValid) {
                    var val = this.constructionDateTypes.find(x => {
                        return x.constructionDateTypeId === this.constructionDateDto.constructionDateTypeId
                    })
                    this.constructionDateDto.constructionDateTypeDescription = val.description
                    this.reconFormDto.constructionDateList.push(this.constructionDateDto)
                    this.constructionDateDto = {}
                    this.$refs.constructionDateModal.close()
                }
            })
        },
        constructionDatesMore () {
            this.$validator.validateAll('constructionDates').then((isValid) => {
                if (isValid) {
                    var val = this.constructionDateTypes.find(x => {
                        return x.constructionDateTypeId === this.constructionDateDto.constructionDateTypeId
                    })
                    this.constructionDateDto.constructionDateTypeDescription = val.description
                    this.reconFormDto.constructionDateList.push(this.constructionDateDto)
                    this.constructionDateDto = {}
                }
            })
        },
        saveForm () {
            this.$validator.validateAll('reconForm').then((isValid) => {
                if (isValid) {
                    var currentFunctions = this.selectedCurrentFunction.map(f => {
                        return {
                            isHistoric: false,
                            isCurrent: true,
                            buildingFunctionId: f
                        }
                    })
                    var historicFunctions = this.selectedHistoricFunction.map(f => {
                        return {
                            isHistoric: true,
                            isCurrent: false,
                            buildingFunctionId: f
                        }
                    })
                    this.reconFormDto.buildingFunctionList = currentFunctions.concat(historicFunctions)
                    buildingReconFormService.put(this.$http, this.reconFormDto, true)
                }
            })
        },
        workflowOnSubmitSuccess () {
        }
    }
}
</script>

<style>

.text-label {
    line-height: 24px !important;
}

.tabContent {
    margin-left: 30px;
}

.sectionHeader {
    overflow: hidden;
}

.sectionHeaderLeft {
    float: left;
    font-size: 18px;
}

.sectionHeaderRight {
    float: right;
}

</style>



// WEBPACK FOOTER //
// BuildingReconForm.vue?aef9ef0e